export class Center {
    public id: number;
    public address1: string;
    public address2: string;
    public postalCode: string;
    public countryIso: string;
    public name: string;
    public web: string;
    public facebook: string;
    public vat: string;
    public slogan: string;
    public image: string;

    constructor(
        id: number,
        address1: string,
        address2: string,
        postalCode: string,
        countryIso: string,
        name: string,
        web: string,
        facebook: string,
        vat: string,
        slogan: string,
        image: string
    ) {
        this.id = id;
        this.address1 = address1;
        this.address2 = address2;
        this.postalCode = postalCode;
        this.countryIso = countryIso;
        this.name = name;
        this.web = web;
        this.facebook = facebook;
        this.vat = vat;
        this.slogan = slogan;
        this.image = image;
    }
}